module.exports = __webpack_public_path__ + "img/collection-engagementRings100Carat.4cbf573.jpg";